export const EXCMRELATION_CREATE_RESET = 'EXCMRELATION_CREATE_RESET'
export const EXCMRELATION_CREATE_SET_CREATED = 'EXCMRELATION_CREATE_SET_CREATED'
export const EXCMRELATION_CREATE_SET_ERROR = 'EXCMRELATION_CREATE_SET_ERROR'
export const EXCMRELATION_CREATE_SET_VIOLATIONS = 'EXCMRELATION_CREATE_SET_VIOLATIONS'
export const EXCMRELATION_CREATE_TOGGLE_LOADING = 'EXCMRELATION_CREATE_TOGGLE_LOADING'
